import { render, staticRenderFns } from "./oganizationOrders.vue?vue&type=template&id=b3be33c2&scoped=true&"
import script from "./oganizationOrders.vue?vue&type=script&lang=js&"
export * from "./oganizationOrders.vue?vue&type=script&lang=js&"
import style0 from "./oganizationOrders.vue?vue&type=style&index=0&id=b3be33c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3be33c2",
  null
  
)

export default component.exports